import httpClient from "../utils/httpClient";

export const CheckLogin = async (loginRequest) => {
    const response = await httpClient.post(`/User/login`, loginRequest);
    return response.data;
};